import styled from "styled-components";

const StyledButton = styled.span`
  .Polaris-Button--plain {
    margin: -0.7rem 0.3rem;
  }
`;

export default StyledButton;
